export default __webpack_public_path__ + "static/media/plain-sticker-B.0bb75995.png";